import {HTMLInputTypeAttribute, useRef} from 'react'
import {Controller, useFormContext, ValidationRule} from 'react-hook-form'
import classNames from 'classnames'

import {ReactComponent as Date} from '../../assets/icons/date.svg'

import styles from './TextInput.module.scss'

interface ITextInputProps {
  className?: string
  type?: HTMLInputTypeAttribute
  label?: string
  name?: string
  placeholder?: string
  pattern?: ValidationRule<RegExp>
  filledColor?: 'primary' | 'secondary' | 'light' | 'transparent' | 'white'
  withBorder?: boolean
  withUseForm?: boolean
  required?: boolean
}
const TextInput = ({
  className,
  type = 'text',
  label,
  name,
  placeholder,
  pattern,
  withBorder = false,
  withUseForm = false,
  required = false,
  filledColor = 'white',
}: ITextInputProps) => {
  const {
    control,
    formState: {errors},
  } = useFormContext()
  const inputRef = useRef(null)
  return (
    <div className={styles.container}>
      {label && (
        <span
          className={classNames(styles.label, {
            [styles.error]: !!errors[name || ''],
          })}>
          {label}
        </span>
      )}
      {withUseForm ? (
        <Controller
          control={control}
          name={name || ''}
          rules={{
            required: required,
            // {value: required, message: t('')},
            pattern: pattern,
          }}
          render={({field: {name, ...rest}}) => (
            <>
              <div
                className={classNames(styles.box, className, styles[`background-${filledColor}`], {
                  [styles.withBorder]: withBorder,
                  [styles.error]: !!errors[name],
                })}>
                <input
                  type={type}
                  placeholder={placeholder}
                  className={classNames(styles.input)}
                  {...rest}
                  ref={inputRef}
                />
                {type === 'date' && (
                  <Date onClick={() => (inputRef as any)?.current.showPicker()} />
                )}
              </div>
              {/* <div className={classNames(styles.errorContainer, {[styles.error]: !!errors[name]})}>
                <div role="alert" className={styles.errorLabel}>
                  {errors[name]?.message?.toString()}
                </div>
              </div> */}
            </>
          )}
        />
      ) : (
        <>
          <div
            className={classNames(styles.box, className, styles[`background-${filledColor}`], {
              [styles.withBorder]: withBorder,
            })}>
            <input
              type={type}
              placeholder={placeholder}
              className={classNames(styles.input)}
              ref={inputRef}
            />
            {type === 'date' && <Date onClick={() => (inputRef as any)?.current.showPicker()} />}
          </div>
          {/* <div className={classNames(styles.errorContainer, {[styles.error]: !!errors[name]})}>
                <div role="alert" className={styles.errorLabel}>
                  {errors[name]?.message?.toString()}
                </div>
              </div> */}
        </>
      )}
    </div>
  )
}

export default TextInput
